module.exports = __webpack_public_path__ + "img/orange_058.2baf3622.png";